import React from 'react';
import { startCase } from 'lodash';
import { View, Field, Card, Table, Text, Page } from '../../components';
import {
  formatCurrencyOnBlur,
  aggregateProjects,
} from '../../../../helpers/utils';
import { Theme } from '../../../../theme';

const INFO = [
  'name',
  'tax_id',
  'type',
  'phone',
  'fax',
  'email',
  'address',
  'website',
  'notes',
];

interface Props {
  data: any;
  meta: any;
}

const FunderSummary = ({ data: funder, meta }: Props) => {
  const { hours, projects, ...statuses } = aggregateProjects(
    funder.projects,
  ) as any;
  const data = Object.entries(
    statuses as Record<string, { count: any; amount: any }>,
  ).map(([status, values]) => ({
    status: startCase(status),
    ...values,
  }));

  const clients = funder.clients.map(({ fullName }) => fullName).join('; ');

  const columns = [
    {
      Header: 'Status',
      accessor: 'status',
      width: 150,
    },
    {
      Header: 'Count',
      accessor: 'count',
      width: 125,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      width: 150,
      Cell: ({ cell: { value } }) =>
        value !== 0 ? formatCurrencyOnBlur(value.toString()) : '-',
    },
  ];

  const contactColumns = [
    {
      Header: 'Name',
      accessor: 'full_name',
    },
    {
      Header: 'Phone',
      accessor: 'phone',
    },
    {
      Header: 'Email',
      accessor: 'email',
    },
    {
      Header: 'Company',
      accessor: 'company',
    },
  ];

  return (
    <>
      <Page meta={meta}>
        <View flexDirection="row">
          <Card flexGrow={1} mr={1}>
            <View
              mb={1}
              borderBottom={`1pt solid ${Theme.colors.primary}`}
              width="100%"
            >
              <Text fontSize="11pt">Funder Information</Text>
            </View>
            {Object.keys(funder)
              .filter((key) => INFO.includes(key))
              .map((key) => (
                <Field
                  key={`info-field_${funder.id}_${key}`}
                  label={startCase(key)}
                  value={funder[key]}
                  width="100%"
                  maxWidth="200pt"
                  mb={3}
                />
              ))}
          </Card>
          <Card flexGrow={1} width="70%">
            <View
              borderBottom={`1pt solid ${Theme.colors.primary}`}
              width="100%"
            >
              <Text fontSize="11pt">Projects Breakdown</Text>
            </View>
            <Field
              fontSize="10pt"
              width="90%"
              label="Clients"
              value={clients}
            />
            <Field
              fontSize="10pt"
              label="Total Projects"
              value={projects.count}
            />
            <Field
              fontSize="10pt"
              label="Total Amount"
              value={
                projects.amount !== 0
                  ? formatCurrencyOnBlur(projects.amount.toString())
                  : 'No Recorded Info'
              }
            />
            <Field fontSize="10pt" label="Total Hours" value={hours} />
            <Table data={data} columns={columns} />
          </Card>
        </View>
      </Page>
      <Page meta={meta}>
        <View break>
          <Card flexGrow={1}>
            <View
              borderBottom={`1pt solid ${Theme.colors.primary}`}
              width="100%"
            >
              <Text fontSize="14pt">Contacts</Text>
            </View>
            <Table data={funder.contacts} columns={contactColumns} />
          </Card>
        </View>
      </Page>
    </>
  );
};

export default FunderSummary;
